// Где находится человек — по его же устройству.
//
// 🪤 Пояс не был проставлен НИ У КОГО. Единственная ручка, умевшая его
// записывать, жила в ГиперТаске, падала на сравнении uuid со строкой, и
// вызывать её всё равно было некому: ни одно приложение о поясе не сообщало.
// Итог — напоминания печатали время по Гринвичу, и человек в Ташкенте видел
// «встреча в 17:36», получая сообщение в 22:36.
//
// Спрашивать человека не нужно: браузер и так знает, где он. Сообщаем один
// раз за запуск и только когда пояс изменился — на переезд и на смену
// устройства этого достаточно.

import { getApiUrl } from './assistentusApi';
import { authHeader } from './authToken';

const REPORTED_KEY = 'unia-reported-timezone';

function browserTimezone(): string | null {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    } catch {
        return null;
    }
}

let inFlight: Promise<void> | null = null;

/** Сообщить службе часовой пояс этого устройства. Тихо, вдогонку, один раз. */
export function reportTimezone(): Promise<void> {
    if (inFlight) return inFlight;
    inFlight = (async () => {
        const tz = browserTimezone();
        if (!tz) return;
        try {
            if (localStorage.getItem(REPORTED_KEY) === tz) return;
        } catch {
            // Приватный режим — просто сообщим ещё раз, вреда нет.
        }
        try {
            const answer = await fetch(getApiUrl('/api/users/me/timezone'), {
                method: 'PUT',
                headers: await authHeader({ 'Content-Type': 'application/json' }),
                body: JSON.stringify({ timezone: tz }),
            });
            if (!answer.ok) return;
            try { localStorage.setItem(REPORTED_KEY, tz); } catch { /* не страшно */ }
        } catch {
            // Сети нет — сообщим при следующем запуске.
        }
    })().finally(() => { inFlight = null; });
    return inFlight;
}

/** Пояс, по которому показываем время. Тот же, что сообщаем службе. */
export function displayTimezone(): string | undefined {
    return browserTimezone() || undefined;
}

/**
 * Подпись под сообщением: «3 сентября, 09:42».
 *
 * 🪤 Время печатается ЯВНО в поясе человека, а не «как получится». Ровно на
 * этом уже обожглись напоминания: они шли по Гринвичу, и человек в Ташкенте
 * читал «встреча в 17:36», получая сообщение в 22:36. Сегодняшние сообщения
 * без даты — она не нужна и только шумит; вчерашние и старше — с датой.
 */
export function messageStamp(when: Date, зона?: string): string {
    const tz = зона ?? displayTimezone();
    const время = new Intl.DateTimeFormat('ru-RU', {
        hour: '2-digit', minute: '2-digit', timeZone: tz,
    }).format(when);

    const день = (d: Date) => new Intl.DateTimeFormat('ru-RU', {
        year: 'numeric', month: '2-digit', day: '2-digit', timeZone: tz,
    }).format(d);

    if (день(when) === день(new Date())) return время;

    const дата = new Intl.DateTimeFormat('ru-RU', {
        day: 'numeric', month: 'long', timeZone: tz,
    }).format(when);
    return `${дата}, ${время}`;
}
